import { defineMessages } from '@cookbook/solid-intl'

// Split out of `request-listing-setup-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Share your Airbnb or Vrbo listing links and the Lodgr team will set up your Lodgr listing for you.',
        id: 'RequestListingSetupPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Request Listing Setup | Lodgr',
        id: 'RequestListingSetupPage.titleMessage',
    }),
}
